<template>
    <div class="effect">
        <div class="h"><span>特效</span> <i class="iconfont iconguanbi" @click.stop="close"></i></div>
        <ul class="nav">
            <li @click="switchMenu(0)" :class="{active: menuIndex == 0}">粒子特效</li>
            <li @click="switchMenu(1)" :class="{active: menuIndex == 1}">天气特效</li>
        </ul>
        <div class="body" v-show="menuIndex == 0">
            <div class="l1">
                <span class="n">火焰大小</span> 
                <div class="slider">
                    <el-slider v-model="fireSize" :step="1" :max="20" :min="0.1" :show-tooltip="false"></el-slider>
                </div>
            </div>
            <div class="btns">
                <el-button  @click.stop="toAddFire" :disabled="isDelete" type="primary" round>添加</el-button>
                <el-button  @click.stop="toDeleteFire" v-if="!isDelete" round>删除</el-button>
                <el-button  @click.stop="deleteComplete" type="warning" v-else round>删除完成</el-button>
            </div>
            <div class="l3">
                <!-- <el-button type="primary" round @click.stop="close">确定</el-button> -->
            </div>
        </div>
        <div class="body" v-show="menuIndex == 1">
            <div class="l1"><span>雨特效</span> <el-switch v-model="isRain" @change="toggleRain" active-color="#1458EA"></el-switch></div>
            <div class="l2">
                <span>等级</span>
                <el-select v-model="rainValue" placeholder="请选择" @change="rainSizeChange" :disabled="!isRain">
                    <el-option v-for="item in rainLevels" :key="item.name" :label="item.name" :value="item.value"></el-option>
                </el-select>
            </div>
            <div class="l1"><span>雪特效</span> <el-switch v-model="isSnow" @change="toggleSnow" active-color="#1458EA"></el-switch></div>
            <div class="l2">
                <span>等级</span>
                <el-select v-model="snowValue" placeholder="请选择" @change="snowSizeChange" :disabled="!isSnow">
                    <el-option v-for="item in snowLevels" :key="item.name" :label="item.name" :value="item.value"></el-option>
                </el-select>
            </div>
            <div class="l3">
                <!-- <el-button type="primary" round @click.stop="close">确定</el-button> -->
            </div>
        </div>
    </div>
</template>

<script>
import BusEvent from '@/busEvent'

export default {

    data(){
        return {
            isRain: false,
            rainValue: 1000,
            rainLevels: [
                { name: '小雨', value: 1000 },
                { name: '中雨', value: 2000 },
                { name: '大雨', value: 4000 }
            ],
            isSnow: false,
            snowValue: 1000,
            snowLevels: [
                { name: '小雪', value: 1000 },
                { name: '中雪', value: 2000 },
                { name: '大雪', value: 4000 }
            ],
            menuIndex: 0,
            fireSize: 5,
            isDelete: false
        }
    },

    computed: {
        viewer: function(){
            return window.viewer
        }
    },

    mounted(){
        this.init()
    },

    methods: {

        init(){
            if( this.viewer.rain ){
                this.rainValue = this.viewer.rain.density
                this.isRain = true
            }
            if( this.viewer.snow ){
                this.snowValue = this.viewer.snow.density
                this.isSnow = true
            }
        },

        toggleRain( value ){
            this.isRain = value
            if( value ){
                this.viewer.addRain()
            }else{
                this.viewer.removeRain()
            }
        },

        rainSizeChange( value ){
            this.isRain = true
            this.viewer.addRain( value )
        },

        toggleSnow( value ){
            this.isSnow = value
            if( value ){
                this.viewer.addSnow()
            }else{
                this.viewer.removeSnow()
            }
        },

        snowSizeChange( value ){
            this.isSnow = true
            this.viewer.addSnow( value )
        },

        switchMenu( index ){
            this.menuIndex = index
            this.fire = null
        },

        toAddFire(){
            this.$message.success('点击放置火焰')
            this.viewer.container.onmousedown = this.addFire.bind(this) 
        },

        addFire(e){
            this.viewer.container.onmousedown = null
            if( e.button == 2 ) return
            var intersect = this.viewer.intersectObject( e, this.viewer.gisGroup )
            if( intersect ){
                this.fire = viewer.addFire( this.fireSize )
                this.fire.position.copy( intersect.point )
            }else{
                const v = this.viewer.pick( e )
                if( v ){
                    this.fire = viewer.addFire( this.fireSize )
                    this.fire.position.copy( v )
                }
            }
            this.viewer.gisManager.changeRotationToUp( this.fire )
        },

        toDeleteFire(){
            this.isDelete = true
            this.$bus.$emit( BusEvent.ToolDisabledChange, true )
            this.$bus.$emit( BusEvent.MenuDisbaledChange, true )
            var targets = this.viewer.root.children.filter(item => item.effectType == "flame")
            this.viewer.hotSpotManager.icon = require('@/assets/img/del.png')
            targets.map(item => {
                this.viewer.hotSpotManager.addMarker({
                    position: item.position,
                    onclick: e => {
                        this.viewer.root.remove( item )
                        e.target.parentNode.removeChild( e.target )
                    }
                })
            })
            this.$message.success('点击火焰删除')
        },

        deleteComplete(){
            this.isDelete = false
            this.viewer.hotSpotManager.defaultLayer.removeAll()
            this.$bus.$emit( BusEvent.ToolDisabledChange, false )
            this.$bus.$emit( BusEvent.MenuDisbaledChange, false )
        },

        close(){
            this.deleteComplete()
            this.$emit('close')
        }
    }
}
</script>

<style lang="scss" scoped>
.effect{
    width: 280px; position: absolute; right: 440px; bottom: 100px; z-index: 1; color: #182C49;
    .h{
        display: flex; justify-content: space-between; padding: 0 10px; background-color: #1458EA; align-items: center; color: #FFF; height: 34px; border-radius: 5px 5px 0 0; font-size: 14px;
        .iconfont{ font-size: 14px; cursor: pointer; }
    }
    .nav{
        height: 34px; background-color: #fff; display: flex; font-size: 14px;
        li{ width: 50%; text-align: center; line-height: 34px; cursor: pointer; position: relative;}
        .active{ color: #1458EA; }
        .active::after{content: ''; display: block; width: 100%; height: 2px; background-color: #1458EA; position: absolute; bottom: -1px; left: 0; }
    }
    .body{
        background-color: #F2F4F6; height: 320px; padding: 12px 20px 0 20px; border-radius: 0 0 5px 5px;
        .l1{
            padding: 10px 0; font-size: 14px; display: flex; justify-content: space-between;  align-items: center;
            /deep/ .el-button--text{
                margin: 0; padding: 0; width: 50px;
            }
            .slider{ width: 60%; margin-left: 10px; }
            .n{margin-top: -5px;}
        }
        .btns{display: flex; padding-bottom: 20px;}
        .l2{ 
            margin: 20px 0; font-size: 14px; display: flex; justify-content: space-between; align-items: center; 
            /deep/ .el-select{ width: 80%; }
        }
        /deep/ .el-button{
            margin-top: 10px; width: 120px; height: 34px;
            span{
                position: relative; top: -2px;
            }
        }
        /deep/ .el-button--primary{
            background-color: #1458EA; border-color: #1458EA;
        }
        .l3{ width: 100%; display: flex; justify-content: center; position: absolute; bottom: 20px; left: 0; }
    }
}
</style>